module.exports = __webpack_public_path__ + "img/6.00589af4.svg";